module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head2"
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "fm-head1"
  }, [_vm._v("A NOTE ON TERMINOLOGY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The acts of searching for missing persons and rescuing those in distress are as old as humanity, but the terminology describing these activities has evolved over time. Before World War I, the terms were generally used separately, referring to the specific acts of searching or rescuing. After the war, the British Royal Air Force (RAF) began using the term "), _c('i', [_vm._v("air-sea rescue")]), _vm._v(" to describe the operations of its Marine Craft Section, responsible for recovering lost crews of Royal Navy and Air Force seaplanes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN1",
      "id": "FT1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The term "), _c('i', [_vm._v("air-sea rescue")]), _vm._v(" became more widely used during World War II. When the conflict began, the Royal Air Force was largely unprepared for the difficult task of recovering downed aviators during the Battle of Britain. In response, it created the Air-Sea Rescue Service in early 1941, later known as the Search and Rescue Force. The group’s motto was, “The sea shall not have them.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN2",
      "id": "FT2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the United States entered the war in late 1941, it borrowed much of what the British had already established, including its terminology. The American military used the British term "), _c('i', [_vm._v("air-sea rescue")]), _vm._v(" for much of the war, reflecting its operational focus on rescuing aviators and sailors lost at sea. In February 1944, the Joint Chiefs of Staff established the Air-Sea Rescue Agency under the Coast Guard to coordinate the military’s rescue operations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the war, the term "), _c('i', [_vm._v("air-sea rescue")]), _vm._v(" gradually fell into disuse as civilian entities began adopting the phrase “search and rescue.” That usage was formally enshrined in May 1945 when the Provisional International Civil Aviation Organization met to establish common standards for international aviation. It selected "), _c('i', [_vm._v("search and rescue")]), _vm._v(" to describe the act of “finding and returning to safety the survivors from an emergency incident.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN3",
      "id": "FT3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" The Pentagon followed suit in 1946 when it officially changed the name of the Air-Sea Rescue Agency to the Search and Rescue Agency.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the mid-1950s, the term "), _c('i', [_vm._v("search and rescue")]), _vm._v(" and the associated acronym SAR were part of the common lexicon. In 1956, the U.S. government published the first edition of its National Search and Rescue Plan. That foundational document defined SAR as “the employment of available personnel and facilities in rendering aid to persons and property in distress.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN4",
      "id": "FT4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" That usage evolved only slightly through the modern era into what is currently found in the National SAR Plan, in which search is defined as “an operation using available personnel and facilities to locate persons in distress” and rescue as “operations to retrieve persons in distress, provide for their initial medical or other needs, and deliver them to a place of safety.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN5",
      "id": "FT5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aabef744","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preface.vue
// module id = 66
// module chunks = 0